/* eslint-disable prettier/prettier */
/*import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import Apptest from 'AppTest'
import { Provider } from 'react-redux'

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import store from './store/store'
const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
        <Provider store={store}>
          <App />
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
// import Apptest from "AppTest"; // si lo usas en desarrollo, puedes alternarlo
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

// Importa store y persistor
import { store, persistor } from './store/store';
import AutoLogout from 'AutoLogout';
import { loadConfig } from "./configLoader"; 
import NetworkStatusModal from "NetworkStatusModal";
const container = document.getElementById("app");
const root = createRoot(container);

loadConfig().then(() => {
  root.render(
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <NetworkStatusModal />
            <AutoLogout warningBefore={3 * 60 * 1000} />
            <App />
          </PersistGate>
        </Provider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  );
});

